export default __webpack_public_path__ + "static/media/chek.cd93c111.png";